import './NoSearchResults.scss';

export const NoSearchResults: React.FC = () => {
  return (
    <p className="no-result">No search results</p>
  );
};
